import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowBackToUpRight = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21.5 6H4V18H20V11.7432L22 9.74316V20H2V4H21.5V6Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" }),
        React.createElement("path", { d: "M18 8.5L21.5 5L18 1.5", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconArrowBackToUpRight.js.map